import { useEffect } from 'react';

export default function AppleCallbackPage() {
  useEffect(() => {
    if (window.opener && typeof window.opener !== 'undefined') {
      try {
        window.close();
      } catch (_) {}
    }
  }, []);

  return null;
}
